
import {User as AuthUser} from 'firebase/auth'
import {NamedEntity, NamedEntityModel} from "./named-entity.model";

export interface User extends NamedEntity {
  email: string;
  api_key_expiration_warning?: number;
}

export class UserModel extends NamedEntityModel<User> {
  readonly email: string;
  readonly apiKeyExpirationWarning?: number;
  authUser?: AuthUser

  constructor(source: User) {
    super(source, 'user');
    this.email = source.email;
    this.apiKeyExpirationWarning = source.api_key_expiration_warning;
  }
}

